import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { EiqDatePicker } from 'eiq-storybook';
import s from './CapEditField.styles';
import sf from '../CapFinding/CapFinding.styles';

const CapEditDatePickerField = ({
  value: valueFromParent,
  onSave,
  editable,
  isRequired,
}) => {
  const { t } = useTranslation();

  const onChangeDatePicker = async date => {
    await onSave(date);
  };

  const InnerText = ({ value, onClick }) => {
    const onClickWithSetEditing = async e => {
      e.persist();
      e.preventDefault();
      e.stopPropagation();

      if (!editable) {
        return;
      }

      onClick();
    };

    const placeHolder = isRequired ? t('REQUIRED') : t('EMPTY');

    return value ? (
      <s.EditDivButton
        border
        editable={editable}
        onClick={onClickWithSetEditing}
        vertical-center
        >
        <sf.Text centerAligned>{value}</sf.Text>
      </s.EditDivButton>
    ) : (
      <s.EditDivButton
        border
        editable={editable}
        isRequired={isRequired}
        onClick={onClickWithSetEditing}
        vertical-center
        >
        <s.PlaceHolderText>{placeHolder}</s.PlaceHolderText>
      </s.EditDivButton>
    );
  };

  InnerText.propTypes = {
    value: PropTypes.datetime,
    onClick: PropTypes.func,
  };

  const DatePickerWrapper = () => (
    <EiqDatePicker
      wrapperClassName="only-date-picker"
      selectedDate={valueFromParent ? new Date(valueFromParent) : null}
      autoComplete="off"
      customInput={<InnerText />}
      dateFormat={'MMMM d, yyyy'}
      onChange={onChangeDatePicker}
      popperModifiers={{
        flip: {
          enabled: false,
        },
        preventOverflow: {
          enabled: true,
          escapeWithReference: false,
        },
      }}
      popperPlacement="bottom-end"
      showTimeSelect={false}
      styles={{ width: '100%' }}
    />
  );

  return <DatePickerWrapper />;
};

CapEditDatePickerField.propTypes = {
  onSave: PropTypes.func,
  editable: PropTypes.bool,
  isRequired: PropTypes.bool,
  value: PropTypes.string,
};

CapEditDatePickerField.defaultProps = {};

export default React.memo(CapEditDatePickerField);
